import { useState, useEffect } from "react";

export function useLocale() {
  const [locale, setLocale] = useState(localStorage.getItem("locale") || "en-US");

  useEffect(() => {
    localStorage.setItem("locale", locale);
    document.dispatchEvent(new CustomEvent("localeChange", { detail: locale }));

    // Forward locale to avatar iframe(s)
    document.querySelectorAll("iframe").forEach((iframe) => {
      iframe.contentWindow?.postMessage({ type: "SET_LOCALE", locale }, "*");
    });
  }, [locale]);

  return { locale, setLocale };
}
